import { Component, Input, OnInit } from "@angular/core";
import { DataService_Student_Scan_History } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-student-scan-view-alerts",
	templateUrl: "./student-scan-view-alerts.component.html",
	styleUrls: ["./student-scan-view-alerts.component.css"],
})
export class StudentScanViewAlertsComponent implements OnInit {
	constructor(private ScanHistoryService: DataService_Student_Scan_History) {}

	ngOnInit(): void {
		this.LoadScanDetails();
	}

	ngOnChanges() {
		this.LoadScanDetails();
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	//Input
	@Input() SelectedEntry: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedScanAlert: any;
	lstScanAlert: any = [];

	//Filter lists
	lstInfractionDesc: any = [];
	lstContinueAlertDesc: any = [];
	lstWeaponTypeDesc: any = [];
	lstPenaltyDesc: any = [];
	lstGroupActionDesc: any = [];
	lstAlertTypeDesc: any = [];
	lstAlertSeverityDesc: any = [];
	lstPriority: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AlertOrder", header: "Alert Order" },
		{ field: "IncidentDT", header: "Incident Date" },
		{ field: "InfractionDesc", header: "Infraction" },
		{ field: "ContinueAlertDesc", header: "Continue Alert" },
		{ field: "WeaponTypeDesc", header: "Weapon Type" },
		{ field: "PenaltyDesc", header: "Penalty" },
		{ field: "GroupActionDesc", header: "Part of Group Action" },
		{ field: "GroupDesc", header: "Group" },
		{ field: "AlertDesc", header: "Alert" },
		{ field: "AlertTypeDesc", header: "Alert Type" },
		{ field: "AlertSeverityDesc", header: "Alert Severity" },
		{ field: "Message", header: "Message" },
		{ field: "Priority", header: "Priority" },
	];

	///////////////

	///////////////////////////////////

	///////////////////////////////////
	// Load Data
	///////////////////////////////////
	LoadScanDetails() {
		if (this.SelectedEntry == undefined) {
			return;
		}

		var result = this.ScanHistoryService.StudentAlertScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				this.lstScanAlert = response;

				for (var i = 0; i < this.lstScanAlert.length; i++) {
					var next = this.lstScanAlert[i];

					next.Scan_AlertID = next.Scan_AlertID != "" ? next.Scan_AlertID : "N/A";
					next.AlertID = next.AlertID != "" ? next.AlertID : "N/A";
					next.IncidentID = next.IncidentID != "" ? next.IncidentID : "N/A";
					next.AlertOrder = next.AlertOrder != "" ? next.AlertOrder : "N/A";
					next.InfractionID = next.InfractionID != "" ? next.InfractionID : "N/A";
					next.IncidentDT = next.IncidentDT != "" ? moment(new Date(next.IncidentDT)).format("MM/DD/YYYY h:mm a") : "N/A";
					next.InfractionDesc = next.InfractionDesc != "" ? next.InfractionDesc : "N/A";
					next.ContinueAlertDesc = next.ContinueAlertDesc != "" ? next.ContinueAlertDesc : "N/A";
					next.WeaponTypeDesc = next.WeaponTypeDesc != "" ? next.WeaponTypeDesc : "N/A";
					next.PenaltyDesc = next.PenaltyDesc != "" ? next.PenaltyDesc : "N/A";
					next.GroupActionDesc = next.GroupActionDesc != "" ? next.GroupActionDesc : "N/A";
					next.GroupDesc = next.GroupDesc != "" ? next.GroupDesc : "N/A";
					next.AlertTypeDesc = next.AlertTypeDesc != "" ? next.AlertTypeDesc : "N/A";
					next.AlertSeverityDesc = next.AlertSeverityDesc != "" ? next.AlertSeverityDesc : "N/A";
					next.AlertDesc = next.AlertDesc != "" ? next.AlertDesc : "N/A";
					next.Message = next.Message != "" ? next.Message : "N/A";
					next.Priority = next.Priority != "" ? next.Priority : "N/A";
					next.MessageFontColor = next.MessageFontColor != "" ? next.MessageFontColor : "N/A";
				}

				//Load Data Filter Lists
				this.lstInfractionDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.InfractionDesc))).sort();
				this.lstContinueAlertDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.ContinueAlertDesc))).sort();
				this.lstWeaponTypeDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.WeaponTypeDesc))).sort();
				this.lstPenaltyDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.PenaltyDesc))).sort();
				this.lstGroupActionDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.GroupActionDesc))).sort();
				this.lstAlertTypeDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.AlertTypeDesc))).sort();
				this.lstAlertSeverityDesc = Array.from(new Set(this.lstScanAlert.map((item: any) => item.AlertSeverityDesc))).sort();
				this.lstPriority = Array.from(new Set(this.lstScanAlert.map((item: any) => item.Priority))).sort();
			},
			(error) => {}
		);
	}
	///////////////////////////////////

	///////////////////////////////////
	// Events
	///////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedScanAlert = val.data;
	}
	onRowUnselect(val) {
		this.SelectedScanAlert = null;
	}
	///////////////////////////////////
}
